import React from 'react'
import Svg from '../../../components/Svg/Svg'
import { SvgProps } from '../../../components/Svg/types'

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 512 512" {...props}>
      <path
        d="M480.422,401.39l-27.485-108.684l-95.729-93.994L303.331,80.61L144.13,130.143l-33.909,114.795l-41.71,10.409
			L31.578,401.39H0v30h512v-30H480.422z M189.245,401.39l13.701-48.623l61.974-35.231l47.094,24.487l25.145,59.367H189.245z
			 M369.25,401.39l0.415-0.176l-34.236-80.83l-71.148-36.995l-86.87,49.386l-19.333,68.615H62.522l30.672-121.283l112.065-27.966
			l-7.264-29.107l-54.004,13.477l24.365-82.487l118.65-36.916l45.214,99.114l93.694,91.996l23.563,93.172H369.25z"
      />
    </Svg>
  )
}

export default Icon
